import { render, staticRenderFns } from "./AddToFamilyNewModal.vue?vue&type=template&id=a99993e8&scoped=true"
import script from "./AddToFamilyNewModal.vue?vue&type=script&lang=js"
export * from "./AddToFamilyNewModal.vue?vue&type=script&lang=js"
import style0 from "./AddToFamilyNewModal.vue?vue&type=style&index=0&id=a99993e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99993e8",
  null
  
)

export default component.exports